import '@babel/polyfill';
// Import Component hooks before component definitions
import './component-hooks';
import Vue from 'vue';
import vuetify from './plugins/vuetify';
import './plugins/vee-validate';
import App from './App.vue';
import router from './router';
import store from '@/store';
import './registerServiceWorker';
import 'vuetify/dist/vuetify.min.css';

Vue.config.productionTip = false;

// TODO move to other file
Vue.directive('prevent-reclick', {
  inserted: function(el, bind) {
    el.addEventListener('click', () => {
      if (!(el as HTMLButtonElement).disabled) {
        (el as HTMLButtonElement).disabled = true;
        setTimeout(() => { 
          (el as HTMLButtonElement).disabled = false;
        },bind.value, 1000);
      }
    });
  }
});

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
